import useScrollReveal from "./shared/useScrollReveal";
import charger60kw from "../../Assets/levdc/levdc-charger2.png";
import charger120kw from "../../Assets/levdc/levdc-charger1.png";

import { Button } from '../../Atoms';
import { useNavigate } from 'react-router-dom';
import { IoChevronForwardOutline } from 'react-icons/io5';
import { BsArrowRightShort } from 'react-icons/bs';

import brochure from "../../Assets/levdc/12kW_LEVDC_V1.pdf";
const ENQUIRE_HREF = "https://www.verdemobility.com/get-in-touch#contact-us";

const VARIANTS = [
  {
    kw: "12 kW",
    name: "Single Gun",
    img: charger60kw,
    alt: "VerdeMobility LEV DC 12 kW Single Gun Charger",
    quick: [
      { label: "Vehicle Compatibility", value: "Type 6" },
      { label: "Output Current", value: "125 A" },
      { label: "Weight", value: "130 kg" },
    ],
    details: [
      "Combo connector — Gun1: Type 6 / Type 7",
      "12 kW continuous output, single connector",
      "1720 × 540 × 275 mm footprint",
    ],
  },
  {
    kw: "12 kW",
    name: "Dual Gun",
    img: charger120kw,
    alt: "VerdeMobility LEV DC 12 kW Dual Gun Charger",
    quick: [
      { label: "Vehicle Compatibility", value: "Type 6 | Type 7" },
      { label: "Output Current", value: "200 A (100 A × 2)" },
      { label: "Weight", value: "60 kg" },
    ],
    details: [
      "Gun1: Type 6 · Gun2: Type 7",
      "6 + 6 kW split across two vehicles at once",
      "525 × 270 × 700 mm footprint",
    ],
  },
];

export default function Variants() {
  const ref = useScrollReveal();

  return (
    <section className="lv-section " id="variants" ref={ref}>
      <div className="lv-container">
        <p className="section-label reveal visible text-center">The Charger</p>
        <h2 className="section-title reveal font-gilroy h3 visible text-center md:pb-10">Same Power. More Choice.</h2>

        <div className="lv-grid">
          {VARIANTS.map((v) => (
            <div className="lv-card reveal" key={v.name}>
              <div className="lv-card-head">
                <h3 className="lv-card-title font-gilroy">
                  <span className="lv-kw-inline">{v.kw}</span> LEV DC Charger — <strong className="lv-name-inline">{v.name}</strong>
                </h3>
              </div>

              <div className="lv-media">
                <img src={v.img} alt={v.alt} />
              </div>

              <div className="lv-quick">
                {v.quick.map((q) => (
                  <div className="lv-quick-item" key={q.label}>
                    <span className="lv-quick-value">{q.value}</span>
                    <span className="lv-quick-label">{q.label}</span>
                  </div>
                ))}
              </div>

              {/* <ul className="lv-details">
                {v.details.map((d) => (
                  <li key={d}>{d}</li>
                ))}
              </ul> */}
            </div>
          ))}
        </div>

        <div className="lv-actions">
          <a href={ENQUIRE_HREF} className="text-gray-600">
            <button className="btn-new font-semibold relative flex justify-center items-center rounded-full pl-16 pr-6 font-poppins">
              <span className="flex justify-center items-center">
                <IoChevronForwardOutline className="h-[22px] w-[25px] ioArrow" />
                <BsArrowRightShort className="h-[30px] w-[30px] tailArrow" />
              </span>
              Book Now
            </button>
          </a>
          <a href={brochure} className="text-gray-600" target="_blank" >
            <button className="btn-new font-semibold relative flex justify-center items-center rounded-full pl-16 pr-6 font-poppins">
              <span className="flex justify-center items-center">
                <IoChevronForwardOutline className="h-[22px] w-[25px] ioArrow" />
                <BsArrowRightShort className="h-[30px] w-[30px] tailArrow" />
              </span>
              Brochure
            </button>
          </a>
        </div>
      </div>

      <style>{`
        .lv-section {
          padding: 72px 0;
        }
        .lv-container {
          max-width: 1120px;
          margin: 0 auto;
          padding: 0 20px;
        }
        .lv-label {
          text-align: center;
          color: #00a85a;
          font-weight: 600;
          margin-bottom: 8px;
        }
        .lv-title {
          text-align: center;
          font-size: clamp(28px, 4vw, 40px);
          color: #12161a;
          margin: 0 0 44px;
          line-height: 1.15;
        }

        .lv-grid {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 28px;
        }
        @media (max-width: 760px) {
          .lv-grid { grid-template-columns: 1fr; }
        }

        .lv-card {
          border: 1px solid #e5e8eb;
          border-radius: 16px;
          padding: 28px 28px 24px;
          background: #fff;
          transition: transform 0.35s ease, border-color 0.35s ease, box-shadow 0.35s ease;
          cursor: default;
        }
        .lv-card:hover {
          transform: translateY(-8px);
          border-color: #00a85a;
          box-shadow: 0 20px 40px -20px rgba(0, 168, 90, 0.35);
        }

        .lv-card-head {
          display: flex;
          align-items: baseline;
          gap: 10px;
          margin-bottom: 18px;
        }
        .lv-kw-inline {
          color: #00a85a;
          font-weight: 700;
        }
        .lv-name-inline {
          font-weight: 700;
        }
        .lv-card-title {
          font-size: 28px;
          color: #12161a;
          margin: 0;
          line-height: 1.3;
        }

        .lv-media {
          border-radius: 12px;
          overflow: hidden;
          background: #f6f8f7;
          margin-bottom: 20px;
        }
        .lv-media img {
          width: 100%;
          height: auto;
          display: block;
          transition: transform 0.5s ease;
        }
        .lv-card:hover .lv-media img {
          transform: scale(1.05);
        }

        .lv-quick {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 12px;
          padding-top: 18px;
          border-top: 1px solid #eef1f0;
        }
        .lv-quick-item {
          display: flex;
          flex-direction: column;
          gap: 2px;
        }
        .lv-quick-value {
          font-weight: 600;
          color: #12161a;
          font-size: 18px;
        }
        .lv-quick-label {
          font-size: 14px;
          color: #8a929a;
        }

        .lv-details {
          list-style: none;
          margin: 0;
          padding: 0;
          max-height: 0;
          opacity: 0;
          overflow: hidden;
          transition: max-height 0.4s ease, opacity 0.3s ease, margin-top 0.4s ease;
        }
        .lv-card:hover .lv-details {
          max-height: 200px;
          opacity: 1;
          margin-top: 16px;
        }
        .lv-details li {
          font-size: 13.5px;
          color: #52585e;
          padding: 6px 0 6px 18px;
          position: relative;
          border-top: 1px solid #f1f3f2;
        }
        .lv-details li:first-child {
          border-top: none;
        }
        .lv-details li::before {
          content: "";
          position: absolute;
          left: 0;
          top: 14px;
          width: 6px;
          height: 6px;
          border-radius: 50%;
          background: #00a85a;
        }

        .lv-actions {
          display: flex;
          justify-content: center;
          gap: 16px;
          margin-top: 44px;
        }
      `}</style>
    </section>
  );
}